document.addEventListener( 'DOMContentLoaded', () => {
	const linkSelectors = document.querySelectorAll( '.wdg-link-selector' );

	const resetSelectors = () => {
		linkSelectors.forEach( select => {
			select.value = ''; // Reset to the default option value
		} );
	};

	// Reset dropdowns on page load and when navigating back
	window.addEventListener( 'pageshow', resetSelectors );

	linkSelectors.forEach( select => {
		select.addEventListener( 'change', function () {
			const selectedUrl = this.value;
			if ( selectedUrl ) {
				window.location.href = selectedUrl;
			}
		} );
	} );
} );
